import { render, staticRenderFns } from "./HallDetail.vue?vue&type=template&id=064b8f4a&scoped=true"
import script from "./HallDetail.vue?vue&type=script&lang=js"
export * from "./HallDetail.vue?vue&type=script&lang=js"
import style0 from "./HallDetail.vue?vue&type=style&index=0&id=064b8f4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064b8f4a",
  null
  
)

export default component.exports